import { useEdgeFunction } from "./00_useEdgeFunction";
import { SearchTextAddressResponse } from "../types";

// 02_search-text-address - matches GraphQL BUILDING_SEARCH_TEXT query
export const useSearchBuildings = (input?: string) => {
  const payload = input ? { input } : undefined;
  const { data, loading, error, execute, reset } =
    useEdgeFunction<SearchTextAddressResponse>("search-buildings", payload);

  // Manual execution method - only execute if input is not empty
  const searchBuildings = (input: string) => {
    if (!input || input.trim() === "") {
      return Promise.resolve();
    }
    return execute({ input });
  };

  return { data, loading, error, searchBuildings, reset };
};
